import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'

import Icon from '../../../Shared/Icon/Icon'

class EditProjectModal extends React.Component {
  constructor() {
    super()

    this.state = { isDisabledSubmit: false }

    this.onConfirm = this.onConfirm.bind(this)
    this.onModalClose = this.onModalClose.bind(this)
  }

  onConfirm() {
    this.setState({ isDisabledSubmit: true })
    window.location.href = `/3d-modeling-jobs/${this.props.slug}/edit`
  }

  onModalClose() {
    this.setState({ isDisabledSubmit: false })
    this.props.closeModal()
  }

  render() {
    return (
      <Modal
        isOpen={this.props.modalIsOpen}
        shouldCloseOnOverlayClick
        onRequestClose={this.onModalClose}
        contentLabel="Modal"
        ariaHideApp={false}
        className={{
          base: '',
          afterOpen: 'overlay-modal--container_after-open overlay-modal-container--xs',
          beforeClose: 'overlay-modal--container_before-close',
        }}
        overlayClassName={{
          base: 'overlay-modal--background',
          afterOpen: 'overlay-modal--background_after-open',
          beforeClose: 'overlay-modal--background_before-close',
        }}
      >
        <div className="overlay-modal">
          <button className="btn btn-transparent overlay-modal--close-inner" onClick={this.onModalClose}>
            <Icon type={['fal', 'times']} color="grey-dark" />
          </button>
          <div className="overlay-modal--content overlay-modal--jobs">
            <div className="l-inner-large">
              <h2 className="modal-title">Edit Project details</h2>
              <p className="modal-description">
                Are you sure you want to edit the details of this Project?
              </p>
              <p className="modal-description">
                If you proceed, applicant(s) will be notified about the updates.
                You won't be able to pay and start working until the selected designer accepts your updated offer
                or edits application.
              </p>
              <p className="modal-description">
                If you still want to edit the Project, press the Continue button below.
              </p>
              <div className="footer u-text-right u-mt10">
                <button className="btn btn-fat btn-outline-default" onClick={this.onModalClose}>Cancel</button>
                <button
                  type="submit"
                  className="btn btn-fat btn-primary u-ml10"
                  disabled={this.state.isDisabledSubmit}
                  onClick={this.onConfirm}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

EditProjectModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  id: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  slug: PropTypes.string.isRequired,
  modalIsOpen: PropTypes.bool,
}

EditProjectModal.defaultProps = {
  modalIsOpen: false,
}

export default EditProjectModal
